module.exports = __webpack_public_path__ + "img/toplogo.943c3903.png";